module.exports = __webpack_public_path__ + "media/printed-materials/05-educator-college-calendar-3eee5848.jpg";